import {Directive} from '@angular/core';
import {AbstractControl, NG_VALIDATORS, Validator} from '@angular/forms';
import {createStaticValidator} from './common';

const SpecialPattern = /[^0-9A-Za-z]/;
export const SpecialChar = createStaticValidator((control: AbstractControl) => SpecialPattern.test(control.value), {
  special: true,
});

@Directive({
  selector: '[specialChar]',
  providers: [{provide: NG_VALIDATORS, useExisting: SpecialCharDirective, multi: true}],
})
export class SpecialCharDirective implements Validator {
  validate = SpecialChar;
}



// WEBPACK FOOTER //
// ./src/app/shared/validators/special-char.validator.ts